import React, { useEffect } from 'react';

export function useOutsideClick(ref: React.RefObject<Element>, callback: (event) => void) {
	useEffect(() => {
		const handleClickOutside = event => {
			if (!ref.current || ref.current.contains(event.target)) {
				return;
			}

			// React 18 may synchronously unmount the clicked element before
			// this document-level handler runs. A detached target is not an outside click.
			if (!event.target.isConnected) {
				return;
			}
			callback(event);
		};

		document.addEventListener('click', handleClickOutside);

		return () => {
			document.removeEventListener('click', handleClickOutside);
		};
	}, [ref, callback]);
}
